const colors = ["#000000", "#434343", "#666666", "#999999", "#b7b7b7", "#cccccc", "#d9d9d9", "#efefef", "#f3f3f3", "#ffffff", "#980000", "#ff0000", "#ff9900", "#ffff00", "#00ff00", "#00ffff", "#4a86e8", "#0000ff", "#9900ff", "#ff00ff", "#e6b8af", "#f4cccc", "#fce5cd", "#fff2cc", "#d9ead3", "#d0e0e3", "#c9daf8", "#cfe2f3", "#d9d2e9", "#ead1dc", "#dd7e6b", "#ea9999", "#f9cb9c", "#ffe599", "#b6d7a8", "#a2c4c9", "#a4c2f4", "#9fc5e8", "#b4a7d6", "#d5a6bd", "#cc4125", "#e06666", "#f6b26b", "#ffd966", "#93c47d", "#76a5af", "#6d9eeb", "#6fa8dc", "#8e7cc3", "#c27ba0", "#a61c00", "#cc0000", "#e69138", "#f1c232", "#6aa84f", "#45818e", "#3c78d8", "#3d85c6", "#674ea7", "#a64d79", "#85200c", "#990000", "#b45f06", "#bf9000", "#38761d", "#134f5c", "#1155cc", "#0b5394", "#351c75", "#741b47", "#5b0f00", "#660000", "#783f04", "#7f6000", "#274e13", "#0c343d", "#1c4587", "#073763", "#20124d", "#4c1130"]

const keyPrefix = '';
const keySuffix = 'loantrackerusa.com';
const key = {
    token: keyPrefix + '.tk.' + keySuffix,
    permission: keyPrefix + '.pm.' + keySuffix,
    userDetail: keyPrefix + '.ud.' + keySuffix,
    workingHours: keyPrefix + '.wh.' + keySuffix,
    version: keyPrefix + '.app.' + keySuffix,
    loanUpdates: keyPrefix + '.lu.' + keySuffix,
}

const permission = {
    public: "0",

    // admin route
    adminLoan: "1",
    adminReport: "2",
    bulkImport: "3",
    manageUserConfiguration: "4",
    manageLoanConfiguration: "5",
    manageLoanStatus: "6",
    // admin route

    // admin route
    teamLoan: "101",
    teamReport: "102",
    // admin route
};

const component = {
    // auth
    login: { url: '/', title: 'Login', permission: permission.public },
    logout: { url: '/logout', title: 'Logout', permission: permission.public },
    forgotPassword: { url: '/forgot-password', title: 'Forgot Password', permission: permission.public },
    resetPassword: { url: '/reset-password', title: 'Reset Password', permission: permission.public },
    register: { url: '/register', title: 'Register', permission: permission.public },
    // auth

    heterIskaSignature: { url: '/pub/heter-iska', title: 'Heter Iska', permission: permission.public },
    feedbackThanks: { url: '/pub/feedback-thanks', title: 'Feedback Thanks', permission: permission.public },
    // profile
    profile: { url: '/profile', title: 'Profile', permission: permission.public },
    changePassword: { url: '/change-password', title: 'Change Password', permission: permission.public },
    // profile

    // loan detail
    loanList: { url: '/loan', title: 'Loan List', permission: permission.public },
    loanDetail: { url: '/loan/detail/:id', title: 'Loan Detail', permission: permission.public },
    // loan detail

    // message
    messageList: { url: '/message', title: 'Message List', permission: permission.public },
    // message
};

const fieldType = {
    string: 'string',
    array: 'array',
    object: 'object',
    date: 'date'
}

const message = {
    recordAdded: 'Record was added successfully', recordUpdated: 'Changes were saved successfully',
    documentAdded: 'Documents were addedd successfully',
    messageAdded: 'Message was posted successfully'
};
const formatting = {
    // dateFormat: 'DD MMM YYYY',
    // timeFormat: 'hh:mm:ss A',
    // monthFormat: 'MMM YYYY',
    // dateTimeFormat: 'DD MMM YYYY hh:mm A',
    // shortDateTimeFormat: 'DD MM YY hh:mm A',

    usDateTimeFormat: 'ddd MM/DD/YYYY hh:mm A',
    usDateFormat: 'MM/DD/YYYY',
    usDateWithDayFormat: 'ddd MM/DD/YYYY',
    // usShortDateTimeFormat: 'MM/DD/YY hh:mm A',
};
const app = { version: '1.3', currency: '$' }
const loanStatus = {
    sentToProcessing: 1,
    processorAssigned: 2,
    application: 3,
    sentToUnderwriter: 4,
    approvedWithConditions: 5,
    submitted: 6,
    ctc: 7,
    scheduledClosing: 8,
    closed: 9,
    funded: 10,
    deniedOrWithdrawn: 11,
    sentDisclosure: 12,
    archived: 13
}

const lenderId = { pennyMac: 14, roc: 15, uwm: 8, aAndD: 37, powerExpress: 17, newrezWholesale: 32, loanStore: 30, nfty: 68 };
const obj = {
    component, key, permission, fieldType, message, formatting, app, colors, loanStatus,
    lenderId
};



export default obj;